import * as React from "react";
import { forwardRef } from "react";
const SvgAirwallex = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M7.283 5.264a.75.75 0 0 1 .7.234l6.963 7.715 5.746-2.585a.75.75 0 0 1 1.006.957l-2.655 6.787a.75.75 0 0 1-1.255.229L7.703 7.426l-3.445 9.417 4.978-1.81a.75.75 0 1 1 .512 1.41l-6.492 2.36a.75.75 0 0 1-.96-.962L6.722 5.742a.75.75 0 0 1 .561-.478Zm8.719 9.12 2.086 2.311 1.544-3.945-3.63 1.633Z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(SvgAirwallex);
export default ForwardRef;
